/* eslint-disable */
import {
  FORMAT_AMERICAN,
  FORMAT_AMERICAN_TIME,
  FORMAT_BRAZIL,
  FORMAT_BRAZIL_TIME,
  FORMAT_TIME,
  format,
} from '../utils/date';

import Vue from 'vue';

const filter = (value, pattern = FORMAT_BRAZIL) => {
  if (!value) return '';
  const dates = Array.isArray(value) ? value : [value];
  return dates.map((date) => format(date, pattern)).join(' ~ ');
};

filter.formats = {
  FORMAT_AMERICAN,
  FORMAT_AMERICAN_TIME,
  FORMAT_BRAZIL,
  FORMAT_BRAZIL_TIME,
  FORMAT_TIME,
};

Vue.filter('dateOut', filter);

export default filter;
/* eslint-enable */
